"use client";

import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Card, CardContent } from "../../../card";

interface ChartDonutProps {
  data: {
    title?: string;
    segments: Array<{ name: string; value: number; color: string }>;
  };
}

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    const data = payload[0];
    return (
      <div className="rounded-lg border border-neutral-200 bg-white p-3 shadow-sm">
        <div className="flex items-center gap-2">
          <div 
            className="h-2 w-2 rounded-full" 
            style={{ backgroundColor: data.payload.fill }} 
          />
          <span className="text-sm font-medium text-neutral-900">{data.name}</span>
        </div>
        <div className="mt-1 pl-4 text-xs text-neutral-500">
           {typeof data.value === 'number' 
             ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data.value) 
             : data.value}
           <span className="ml-1 text-neutral-400">({(data.payload.percent * 100).toFixed(1)}%)</span>
        </div>
      </div>
    );
  }
  return null;
};

export const ChartDonut = ({ data }: ChartDonutProps) => {
  if (!data?.segments || !Array.isArray(data.segments)) return null;

  return (
    <Card className="my-8">
      <CardContent className="p-6">
        {data.title && <h3 className="text-lg font-semibold text-neutral-900 mb-6">{data.title}</h3>}
        <div className="h-[400px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data.segments}
                cx="50%"
                cy="50%"
                innerRadius={80}
                outerRadius={120}
                paddingAngle={2}
                dataKey="value"
                stroke="none"
              >
                {data.segments.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend 
                verticalAlign="bottom" 
                height={36}
                formatter={(value) => <span className="text-sm font-medium text-neutral-600 ml-1">{value}</span>} 
                iconType="circle"
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
